/**
 * 获取DOM元素视口距离
 * @param element HTML元素
 */
export var getElementOffset = function (element) {
    try {
        var rect = element.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
        };
    }
    catch (_) {
        return {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
        };
    }
};
//# sourceMappingURL=get-element-offset.js.map